<template>
  <color-banner bgStyle="bg-goods"></color-banner>
  <custom-modal
    ref="importStringsLayouts"
    extra-class="bg-violet-300 text-white/90 font-medium fill-white/90"
    container-class="w-1/2"
  >
    <template v-slot:header>
      {{ $t("strings-layouts.importTitle") }}
    </template>
    <template v-slot:body>
      <excel-importer
        buttonStyle="button-goods"
        importer="StringsLayouts"
        @strings-layouts-has-been-imported="onStringsLayoutsHasBeenImported"
      />
    </template>
  </custom-modal>
  <base-container>
    <template v-slot:buttons>
      <base-button @click="$refs.importStringsLayouts.openModal()" :title="$t('buttons.importExcel')"
        extra-class="fill-white bg-violet-200 hover:bg-transparent hover:fill-violet-400 border-violet-500
        dark:bg-transparent dark:fill-violet-300 dark:hover:bg-violet-300 dark:hover:fill-slate-600">
        <import-excel />
      </base-button>
    </template>
    <template v-slot:title>
      {{ $t("strings-layouts.strings-layouts") }}
    </template>
    <template v-slot:body>
      <strings-layout-row
        v-for="layout in stringsLayouts"
        :key="layout.id"
        :strings-layout="layout"
        class="mb-4"
      />
    </template>
  </base-container>
</template>

<script>
import { useToast } from 'vue-toastification';
import { mapActions, mapGetters } from 'vuex';

import ImportExcel from '@/components/graphics/ImportExcel.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import CustomModal from '../components/base/CustomModal.vue';
import StringsLayoutRow from '../components/stringslayouts/StringsLayoutRow.vue';
import ExcelImporter from '../components/base/ExcelImporter.vue';
import BaseContainer from '../components/base/BaseContainer.vue';
import ColorBanner from '../components/graphics/ColorBanner.vue';

export default {

  components: {
    CustomModal,
    StringsLayoutRow,
    ExcelImporter,
    BaseContainer,
    ColorBanner,
    ImportExcel,
    BaseButton,
  },

  setup() {
    const toast = useToast();

    return { toast };
  },

  async created() {
    await this.getStringsLayouts();
  },

  computed: {
    ...mapGetters('stringsLayouts', ['stringsLayouts']),
  },

  methods: {
    ...mapActions('stringsLayouts', ['getStringsLayouts']),
    async onStringsLayoutsHasBeenImported() {
      await this.getStringsLayouts();
      this.toast.success(this.$t('strings-layouts.imported'));
      this.$refs.importStringsLayouts.closeModal();
    },
  },
};
</script>
